// extracted by mini-css-extract-plugin
module.exports = {"main-component":"eventAlertBackground_main-component__1Q0fl"};